import React from "react";
import { useNavigate } from "react-router-dom";
import MfaNudgeModal from "./MfaNudgeModal";
import useMfaNudge from "./useMfaNudge";

export const SECURITY_PATH = "/manage-account/security";

// Mounted once in the signed-in shell (RootWrapper). Renders nothing unless useMfaNudge says a prompt is due.
// "Set up now" hands off to the existing Security-page setup via router state; it is not a skip. With the SMS
// choice (docs/specs/sms-factor.md §1) "Continue" hands off the picked factor, "totp" | "sms", instead of `true`.
const MfaNudgeHost = () => {
  const { open, offerSms, skip, close } = useMfaNudge();
  const navigate = useNavigate();
  const setUp = (factor) => {
    close();
    navigate(SECURITY_PATH, { state: { startSetup: offerSms ? factor : true } });
  };
  return open ? <MfaNudgeModal open offerSms={offerSms} onSetUp={setUp} onSkip={skip} /> : null;
};

export default MfaNudgeHost;
